export const FormControlLabel = {
  baseStyle: {
    mb: 2,
    _light: {
      _text: {
        fontWeight: 700,
        color: 'text.800',
      },
      _invalid: {
        _text: {
          color: 'error.500',
        },
      },
    },
    _astrick: {
      display: 'none',
    },
  },
}

export const FormControlHelperText = {
  baseStyle: {
    _light: {
      _text: {
        color: 'gray.600',
        fontSize: 'sm',
      },
    },
  },
}
